module.exports = __webpack_public_path__ + "static/media/42.fe5f2536.jpeg";